import type {SupportedCountries} from '@/lib/locale/country'
import simpleStorage from '@/utils/simpleStorage'

export const CART_KEY = `guest-cart`

function getCartKey(country: SupportedCountries) {
  return `${CART_KEY}-${country}`
}

export interface CartV1 {
  country: SupportedCountries
  delivery: {
    fee: number
  }
  wallet: {
    availableBalance: 0
    frozenBalance: 0
  }
  discount: number
  items: {
    id: string
    image: string
    price: number
    retailer: string
    title: string
    url?: string
    quantity: number
    variation?: Record<string, string>
  }[]
}

// TODO: handle db, type migration

export function migrateCartV1ToSupportCountry() {
  const cart = simpleStorage.get(CART_KEY)

  const cartKey = getCartKey('US')

  if (cart && typeof cart === 'object' && !('country' in cart)) {
    // @ts-expect-error: country is not defined in old CartV1
    cart.country = 'US'
    simpleStorage.set(cartKey, cart)
  }
}

function getCart(country: SupportedCountries): CartV1 {
  // TODO: validate cart
  return simpleStorage.get(getCartKey(country), {
    // TODO: get delivery data from BE
    country,
    delivery: {
      fee: 0,
    },
    wallet: {
      availableBalance: 0,
      frozenBalance: 0,
    },
    discount: 0,
    items: [],
  }) as CartV1
}

// add, change, remove
function updateCart(
  {
    country,
    items,
  }: {
    country: SupportedCountries
    items: CartV1['items']
  },
  replace: boolean = false,
) {
  // item = 0: remove
  // item > 0, replace = false: add
  // item > 0, replace = true: change

  const cartKey = getCartKey(country)

  const currentCart = getCart(country)

  items.forEach(item => {
    const existItemIndex = currentCart.items.findIndex(i => {
      return i.id === item.id && i.retailer === item.retailer
    })

    if (item.quantity === 0) {
      // Remove item
      if (existItemIndex !== -1) {
        currentCart.items.splice(existItemIndex, 1)
      }
    } else if (existItemIndex !== -1) {
      // Add item
      const existItem = currentCart.items.at(existItemIndex)
      if (existItem) {
        currentCart.items[existItemIndex] = {
          ...item,
          quantity: !replace ? existItem.quantity + item.quantity : item.quantity, // Replace item
        }
      }
    } else {
      currentCart.items.unshift(item)
    }
  })

  currentCart.discount = 0

  return simpleStorage.set(cartKey, currentCart)
}

function clearCart(country: SupportedCountries) {
  simpleStorage.remove(getCartKey(country))
}

export default {getCart, updateCart, clearCart}
